import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserTermsAndConditionsHasAccepted } from 'common/redux/userTermsAndConditions/userTermsAndConditionsSlice';
import UnexpectedError from 'common/components/UnexpectedError';
import { resetDivestitureDiagnostic } from 'features/divestitureDiagnostic/divestitureDiagnosticSlice';
import { resetProject } from 'features/project/projectSlice';
import PrivateRoute from 'features/security/PrivateRoute';
import ProjectsPage from 'features/projects/ProjectsPage';
import Access from 'features/security/Access';
import Landing from 'features/security/Landing';
import TermsAndConditions from 'features/termsAndConditions/TermsAndConditions';
import TermsAndConditionsView from 'features/termsAndConditions/components/TermsAndConditionsView/TermsAndConditionsView';

const NonProjectContentRouter = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetProject());
    dispatch(resetDivestitureDiagnostic());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tAndCHasAccepted = useSelector(getUserTermsAndConditionsHasAccepted);

  return (
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route exact path="/access" component={Access} />
      <Route
        exact
        path="/unauthorized"
        render={() => (
          <UnexpectedError
            statusCode="403"
            description="You are not authorized to view this content."
          />
        )}
      />
      <Route
        exact
        path="/notfound"
        render={() => (
          <UnexpectedError statusCode="404" description="Page Not Found." />
        )}
      />
      <PrivateRoute
        exact
        path="/policies/:policyId"
        component={TermsAndConditionsView}
        tAndCHasAccepted={tAndCHasAccepted}
      />
      <PrivateRoute
        exact
        path="/terms-and-conditions"
        component={TermsAndConditions}
        requireTAndCAcceptance={false}
      />
      <PrivateRoute
        exact
        path="/projects"
        component={ProjectsPage}
        tAndCHasAccepted={tAndCHasAccepted}
      />
      {children}
      <Route
        component={() => (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        )}
      />
    </Switch>
  );
};

export default NonProjectContentRouter;
